import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const TRUNCATE_LENGTH = 80;
function TestimonialText({
  text
}: {
  text: string;
}) {
  const {
    t
  } = useLanguage();
  const [expanded, setExpanded] = useState(false);
  const needsTruncation = text.length > TRUNCATE_LENGTH;
  const displayText = !expanded && needsTruncation ? text.slice(0, TRUNCATE_LENGTH).trimEnd() + '...' : text;
  return <div className="text-[#5C3D2E] font-light leading-relaxed mb-8 flex-grow italic" data-id="element-244">
      <span data-id="element-245">"{displayText}"</span>
      {needsTruncation && <button onClick={() => setExpanded(!expanded)} className="ml-1 text-[#C9956A] not-italic font-medium text-sm hover:underline transition-colors" data-id="element-246">
          {expanded ? t('test_less') : t('test_more')}
        </button>}
    </div>;
}
const StarRating = () => <div className="flex gap-1 mb-4" data-id="element-247">
    {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-[#F0D060]" fill="currentColor" viewBox="0 0 20 20" data-id="element-248">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-249" />
      </svg>)}
  </div>;
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    name: 'María Florencia Sánchez',
    time: t('test1_time'),
    text: t('test1_text')
  }, {
    name: 'Pamela Colusso',
    time: t('test2_time'),
    text: t('test2_text')
  }, {
    name: 'Ana Sottile',
    time: t('test3_time'),
    text: t('test3_text')
  }];
  return <section className="w-full py-24 bg-[var(--warm-cream)]" data-id="element-250">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-251">
        <div className="text-center mb-16" data-id="element-252">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-253">
            <h2 className="font-serif text-sm tracking-[0.3em] uppercase text-[#C9956A] mb-4" data-id="element-254">
              {t('test_label')}
            </h2>
            <h3 className="font-serif text-4xl md:text-5xl text-[#2C1810]" data-id="element-255">
              {t('test_title')}
            </h3>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-256">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-gray-100 flex flex-col h-full" data-id="element-257">
              <StarRating data-id="element-258" />
              <TestimonialText text={testimonial.text} data-id="element-259" />
              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-260">
                <div className="w-10 h-10 rounded-full bg-[#FDF6F0] flex items-center justify-center text-[#C9956A] font-serif text-xl border border-[#D4AF37]/30" data-id="element-261">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-262">
                  <h4 className="font-medium text-[#2C1810] text-sm" data-id="element-263">
                    {testimonial.name}
                  </h4>
                  <span className="text-xs text-gray-500" data-id="element-264">
                    {testimonial.time}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}